import {
  DEFAULT_WEIGHT,
  PASSENGER_GROUP,
  ROW_GROUP,
  WEIGHT_UNITS
} from './weight-and-balance.consts';
import {eventDuration} from './weight-and-balance';

import { convertKgToLbs, convertLbsToKg } from '../../utils/weight-conversion';
import { DEFAULT_PASSENGER } from './weight--and-balance-manifest/weight-and-balance-manifest.constants';
import { LOCALE } from '../../common/locale/locale.consts';

export const getDefaultSeats = n => Array.from(Array(n).fill(null));

export const convertToAbsoluteWeight = (weight, unit) =>
  unit === WEIGHT_UNITS.kg ? convertKgToLbs(weight) : weight;

export const convertToActualWeight = (weight, unit) =>
  unit === WEIGHT_UNITS.kg ? convertLbsToKg(weight) : `${weight}`;

export const formatNumber = (str = '') =>
  !str ? '-' : Number(str.replace(',', '.')).toLocaleString(LOCALE, {
    minimumFractionDigits: 2
  });

export const getPredefinedPassengers = (
  availablePassengers,
  passengers,
  row,
  col,
  currentFullName
) =>
  availablePassengers.filter(
    ({ fullName }) =>
      !passengers.some((seatsRow, r) =>
        seatsRow.some((p, c) => {
          const hasPlace = p && p.fullName === fullName;
          const isCurrentPassenger = r === row && c === col;

          return isCurrentPassenger && hasPlace ? currentFullName === fullName : hasPlace;
        })
      )
  );

export const normalizeValue = (value, digits) => parseFloat(value || DEFAULT_WEIGHT, 10).toFixed(digits);

export const getWeightAndBalanceFields = (weightAndBalanceTable, passengers, seatRows, reverseManifestSeatNumbers) =>
  Object.keys(weightAndBalanceTable || {}).reduce((acc, key) => {
    const item = weightAndBalanceTable[key];
    const showCGValues = localStorage.getItem('showCGValues') === 'true';

    if (Array.isArray(item) && key === "status") {
      return [
        ...acc,
        {status: item},
        ]
    }

    if (Array.isArray(item)) {
      const rows = [];
      let seatsIndex = 0;
      let firstItemTitle;
      let rowSeatIndex;

      item.forEach((row, rowIndex) => {
        if (seatRows) {
          const seatRow = seatRows.find(({ name }) => name === row.Name);

          if (reverseManifestSeatNumbers && rowIndex !== 0) {
            rowSeatIndex = seatsIndex + seatRow.seats + 1;
            seatsIndex = seatsIndex + seatRow.seats;
          }

          rows.concat(
            getDefaultSeats(seatRow.seats).map((_, c) => {
              let itemSubTitle;
              if (reverseManifestSeatNumbers && rowIndex !== 0) {
                itemSubTitle = rowSeatIndex - 1;
                rowSeatIndex = itemSubTitle;
              } else {
                if (seatsIndex === 0 && !firstItemTitle) {
                  firstItemTitle = "Pilot";
                } else {
                  seatsIndex = seatsIndex + 1;
                }
                itemSubTitle = seatsIndex || firstItemTitle;
              }

              const passenger =
                (passengers && passengers[rowIndex] && passengers[rowIndex][c]) || DEFAULT_PASSENGER;

              rows.push({
                group: PASSENGER_GROUP,
                title: `${itemSubTitle}. ${passenger.fullName}`,
                weight: {
                  value: passenger.weight
                },
                bookingId: passenger.bookingId
              });
            })
          );
        }

        rows.push({
          id: row.Name,
          title: row.Name,
          arm: row.Arm,
          moment: row.Moment,
          group: ROW_GROUP,
          weight: {
            name: row.Name,
            editable: row.Edit,
            value: row.Weight
          }
        });
      });

      return [...acc, ...rows];
    }

    if (typeof item === "string") {
      return [
        ...acc,
        {
          id: key,
          title: key,
          code: item,
        }
      ];
    }

    let secureWeight;
    if (key === eventDuration) {
      secureWeight = Number(item.Weight).toFixed(10);
    }


    let field = {
      id: key,
      title: key,
      group: null,
      weight: {
        select: item.Select,
        value: secureWeight || item.Weight,
        name: key,
        editable: item.Edit
      },
      arm: item.Arm,
      moment: item.Moment,
      status: item.status,
      isTime: item.isTime,
    };

    if (showCGValues && item.envelop) {
      const { aft_cg, forward_cg, weight_cg } = item.envelop

      field = {
        ...field,
        envelop: {
          afterCg: aft_cg,
          forwardCg: forward_cg,
          cg: weight_cg
        }
      }
    }

    return [ ...acc, field ];
  }, [])

